import PromisePolyfill from "promise-polyfill";

// Detects IE8+ (IE8, IE9, IE10, IE11) via `document.documentMode`, which was
// introduced in IE8. `MSInputMethodContext` is IE11-only and is therefore
// NOT used here so that IE8/IE9 are covered as well.
const isLegacyIE =
  typeof window !== "undefined" &&
  typeof document !== "undefined" &&
  !!(document as any).documentMode;

// `babel-polyfill` (core-js@2 + regenerator-runtime) exists only to support legacy
// IE browsers (IE8, IE9, IE11): modern browsers already implement everything it
// provides natively, so running it there is pure parse/eval cost on the critical
// path for no benefit.
//
// It cannot simply move into the lazily-loaded `./ie11` shim, because that shim is
// pulled in via a dynamic `import()`, and Webpack's chunk loader requires a global
// `Promise` to already exist. We install a minimal `Promise` first (via
// `promise-polyfill`) synchronously before any `import()` call is evaluated.
//
// `legacyIeBootstrapReady` resolves once the IE legacy polyfills are fully loaded.
// `main.ts` awaits this promise before calling `loadPolyfills()` to prevent a race
// where `babel-polyfill` is still loading when the rest of the app bootstraps.
if (typeof window !== "undefined" && !(window as any).Promise) {
  (window as any).Promise = PromisePolyfill;
}

export const legacyIeBootstrapReady: Promise<unknown> = isLegacyIE
  ? import(
      /* webpackChunkName: "polyfills/babel-polyfill" */
      "babel-polyfill"
    )
  : Promise.resolve();
